import { render } from "./WNWhitelistCY.vue?vue&type=template&id=544e4fba&scoped=true"
import script from "./WNWhitelistCY.vue?vue&type=script&lang=js"
export * from "./WNWhitelistCY.vue?vue&type=script&lang=js"

import "./WNWhitelistCY.vue?vue&type=style&index=0&id=544e4fba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-544e4fba"

export default script